import { RippleModule } from 'primeng/ripple';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { BehaviorSubject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'new-prospect',
  templateUrl: './new-prospect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    TranslateModule
]
})
export class NewProspectComponent implements OnInit {
  @Output() onAction = new EventEmitter();
  selectedClient: any = new Map()
  clients: any = new BehaviorSubject([])
  constructor() { }

  ngOnInit(): void {
  }

  get getSelectedClientData(): Array<any> {
    return [...this.selectedClient.values()];
  }

  OpenPopup() {
    this.onAction.emit({action:"CreateProspect"});
  }
}
